var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-group w-auto" },
    [
      _c("div", { staticClass: "input-group-prepend" }, [
        _c(
          "div",
          { staticClass: "input-group-text" },
          [
            _c("ItpIcon", {
              attrs: { icon: "material-symbols:numbers-rounded" }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("ItpFormSelect", {
        attrs: {
          name: "numbering",
          options: _vm.options,
          valueField: "id",
          textField: "description",
          readonly: _vm.options.length == 1
        },
        on: {
          input: function($event) {
            return _vm.evh_5962862420439144_input($event, {})
          }
        },
        model: {
          value: _vm.selectedID,
          callback: function($$v) {
            _vm.selectedID = $$v
          },
          expression: "selectedID"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }